import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getRoleDataWithId, updateRole } from "adminApi/RoleManageApi/RoleManage";
import { validateForm } from "utils/validation";
import { RoleRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditRoleForm from "./Componates/EditRoleForm";
import fields from "../json/RoleLisrFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const RoleEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { formdata } = fields;       

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues } = useFormChange(initialValues, RoleRules);

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getRoleDataWithId, setValues);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await updateRole({ id, data: formData });
    },
    (vals) => validateForm(vals, RoleRules),
    () => navigate(-1),
    "Role updated successfully"
  );

  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditRoleForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update Role"
      />
    </>
  );
};

export default RoleEdit;
